module.exports = __webpack_public_path__ + "img/DO.2d8ebb96.png";